import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { TrendingUp, AlertTriangle, DollarSign } from 'lucide-react';
const stats = [{
  icon: TrendingUp,
  number: '85%',
  label: 'de los empleos del 2030 aún no existen',
  color: '#0EA5E9'
}, {
  icon: AlertTriangle,
  number: '300M',
  label: 'de empleos serán reemplazados por la IA en la próxima década',
  color: '#F43F5E'
}, {
  icon: DollarSign,
  number: '3×',
  label: 'más ganarán quienes dominen la IA vs. quienes no',
  color: '#F59E0B'
}];
export function UrgencySection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-24 px-4 relative overflow-hidden" style={{
    backgroundColor: '#050A14'
  }} data-id="element-249">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 70% 55% at 50% 50%, rgba(244,63,94,0.05) 0%, transparent 65%)'
    }} data-id="element-250" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-xs font-black tracking-widest uppercase mb-5 inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{
        color: '#F43F5E',
        backgroundColor: 'rgba(244,63,94,0.07)',
        border: '1px solid rgba(244,63,94,0.2)'
      }} data-id="element-252">
          ⚠️ EL COSTO DE NO ACTUAR
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="text-4xl md:text-5xl font-black mb-7 leading-tight" style={{
        color: '#F59E0B'
      }} data-id="element-253">
          Cada año sin preparación es una ventaja que tu hijo le regala a sus
          competidores.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg mb-14 max-w-3xl mx-auto leading-relaxed" style={{
        color: '#94A3B8'
      }} data-id="element-254">
          Cada año que pasa sin preparación estratégica es una ventaja que tu
          hijo le cede a los hijos de los ejecutivos de Silicon Valley que{' '}
          <strong style={{
          color: '#F1F5F9'
        }} data-id="element-255">
            SÍ están invirtiendo en esto.
          </strong>
        </motion.p>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-5 mb-14" data-id="element-256">
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 40
          }} animate={inView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.65,
            delay: 0.3 + i * 0.12
          }} className="p-8 rounded-2xl text-center" style={{
            backgroundColor: '#0C1628',
            border: `1px solid ${stat.color}18`,
            borderTop: `3px solid ${stat.color}`
          }} data-id="element-257">
                <Icon size={30} className="mx-auto mb-4" style={{
              color: stat.color
            }} data-id="element-258" />
                <div className="text-5xl font-black mb-3" style={{
              color: stat.color
            }} data-id="element-259">
                  {stat.number}
                </div>
                <p className="text-sm leading-relaxed" style={{
              color: '#94A3B8'
            }} data-id="element-260">
                  {stat.label}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Closing */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="p-8 rounded-2xl" style={{
        backgroundColor: '#0C1628',
        border: '1px solid rgba(14,165,233,0.18)'
      }} data-id="element-261">
          <p className="text-2xl font-black leading-snug" style={{
          color: '#F1F5F9'
        }} data-id="element-262">
            La pregunta no es si la IA cambiará el mundo de tu hijo.
            <br data-id="element-263" />
            <span style={{
            color: '#0EA5E9'
          }} data-id="element-264">
              La pregunta es: ¿Quién le enseñará a liderarlo?
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}